var React = require('react');

function Barge (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Mining Barge"),React.createElement("path",{"id":"path1191-9","className":"cls-1","d":"M114,54,94,34H34L14,54V94H114Z","key":2})]);
}

Barge.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Barge;

Barge.default = Barge;
